export const INCIDENTS_STRATEGIES = {
  FILTERED_ISSUES: 'filtered_issues',
  REPORTED: 'reported'
};
